import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import TextArea from 'antd/lib/input/TextArea';
import Modal from 'antd/lib/modal';
import Typography from 'antd/lib/typography';
import { PjmComment } from 'src/domain/pjm/dto/PjmComments';

interface RegistrationCommentModalProps {
    value: PjmComment;
    onClose: (actionTaken: boolean) => void;
    onChange: (data: PjmComment) => void;
}

export function RegistrationCommentModal({ value, onClose, onChange }: RegistrationCommentModalProps) {
    const [form] = Form.useForm<any>();

    function onFormFinish(data: PjmComment) {
        console.info('RegistrationCommentModal onFormFinish', data);
        onChange(data);
    }

    return (
        <Modal
            title="Add Comment"
            className="pjm-registration-comment-modal"
            open
            destroyOnHidden
            maskClosable={false}
            keyboard={false}
            onCancel={() => onClose(false)}
            width="500px"
            footer={[
                <Button key={makeKey('cancel')} onClick={() => onClose(false)}>
                    Cancel
                </Button>,
                <Button key={makeKey('submit')} type="primary" onClick={form.submit}>
                    Save
                </Button>,
            ]}
        >
            <Form form={form} name={makeKey('form')} preserve={false} layout="vertical" onFinish={onFormFinish} initialValues={value}>
                <Form.Item name={['timestamp']} hidden>
                    <Input />
                </Form.Item>

                <Form.Item
                    name={['commentDetails']}
                    label={<Typography.Text strong>Comment</Typography.Text>}
                    hasFeedback
                    rules={[{ max: 500, message: 'Comment must not be more than 500 characters' }]}
                >
                    <TextArea rows={4} maxLength={500} showCount />
                </Form.Item>
            </Form>
        </Modal>
    );
}

function makeKey(label: string) {
    return `pjm-registration-comment-${label}`;
}
